import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%',
  },
};


export default function EditKitab({
    editKitabInfo,
    setEdit,
    edit,
}) {
    const [kitabEditInfo, setKitabEditInfo] = useState({});
    const [kitabList, setKitabList] = useState([]);

    useEffect( ()  => {     
        async function fetchData() {   
         const kitabName = await axios.get(`https://ahlehaqserver.herokuapp.com/api/kitabName`)
         setKitabList(kitabName.data.response);
        }
        fetchData(); 
        setKitabEditInfo(editKitabInfo)
      },[])

    const kitabEdit = async (e) => {
        e.preventDefault();
        try {
            const kitabInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/kitab/${editKitabInfo._id}`,
              kitabEditInfo
            );
    
            //if request success, will show success notification
            if (kitabInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Kitab edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };

    return (
        <>
        <Modal isOpen={edit} style={customStyles}>
        <h1 className="ml-4">Edit a kitab</h1>
        <form onSubmit={kitabEdit}>
                      <div className="row">
                         <div className="col-md-6">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select Book Name<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="kitabName"
                                value={kitabEditInfo?.kitabName || ""}
                                required
                                onChange={(e) =>
                                    setKitabEditInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                    "Choose from the list"
                                </option>
                                {kitabList &&
                                  kitabList.map((data) => (
                                    <option value={data.kitabName}>
                                      {data.kitabName}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>

                         {
                           kitabList && kitabList.find(data => data.kitabName === kitabEditInfo.kitabName)?.pdf === true ? 
                           <div className="col-md-6">
                           <div className="form-group">
                             <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                             Write pdf link <span className="text-danger">*</span>
                             </label>
                             <input
                               type="text"
                               className="form-control rounded"
                               placeholder="Write pdf link"
                               id="exampleInputPassword1"
                               name="pdfUrl"
                               value={kitabEditInfo?.pdfUrl || ""}
                               required
                               onChange={(e) =>
                                 setKitabEditInfo((prev) => ({
                                   ...prev,
                                   [e.target.name]: e.target.value,
                                 }))
                               }
                             />
                           </div>
                          </div>
                            : 
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                                  Chapter Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control rounded"
                                    placeholder="Write Chapter Title"
                                    id="exampleInputPassword1"
                                    name="chapter"
                                    value={kitabEditInfo?.chapter || ""}
                                    required
                                    onChange={(e) =>
                                      setKitabEditInfo((prev) => ({
                                        ...prev,
                                        [e.target.name]: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>

                                
                              <div className="col-md-12">
                              <div className="form-group">
                                    <label for="exampleInputEmail1" className="font-weight-bold">
                                      Write Description<span className="text-danger">*</span>
                                    </label>
                              
                                          <CKEditor
                                              editor={ ClassicEditor }
                                              data={kitabEditInfo?.description || ""}
                                              onChange={ ( event, editor ) => {
                                                  const data = editor.getData();
                                                  setKitabEditInfo((Prev) => ({ ...Prev, description: data }))
                                              } }
                                          />
                                  </div>   
                              </div>  
                            </>
                         }
                          
                          <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 
                      </div>

                      
                    </form>
        </Modal>           
        </>
    )
}
